export const sleep = function (ms: number): Promise<void> {
    return new Promise((resolve) => {
        const timer = setTimeout(() => {
            resolve();
            clearTimeout(timer);
        }, ms);
    });
};
